import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";

/**
 * HelpComponent
 *
 * @export HelpComponent
 */
@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
})
export class HelpComponent implements OnInit {

  selectedCategory: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}


  ngOnInit() {
    this.router.events.subscribe((res) => {
      if (res instanceof NavigationEnd) {
        this.selectedCategory = this.route.snapshot.paramMap.get('category');
      }
    });
  }
}
